
<ct-button [configuration]="submitButton"></ct-button>
